const constants = {
  IS_PRODUCTION: (process && process.env && process.env.NODE_ENV === 'production'),
  SCROLL_ELEMENT: () => window.document.documentElement || window.document.body,
};

if (!constants.IS_PRODUCTION) {
  constants.REQUEST_TIMEOUT = 60000;
} else {
  constants.REQUEST_TIMEOUT = 30000;
}

export default constants;
